<template>
  <div v-if="feedbacks.data">
    <DashboardTitleSearch
      :property-name="property_name"
      :property-id="property_id"
    />
    <h2>Customer Journey: {{ cat_name }} in {{ channel_name }} Channel</h2>
    <span v-if="!feedbacks.data.length">No Feedback!</span>

    <div v-if="stats.data" class="full-box header-boxes">
      <div class="dashboard-box-horizontal four-lines">
        <div class="box-number">#{{ rank }}</div>
        <span class="box-header space-5"
          >Impact Rank in {{ stats.data.category_channel_name }} Channel</span
        >
        <div class="box-number">{{ satisfaction_percentage }}%</div>
        <span class="box-header">Satisfaction Impact</span>
      </div>
      <div class="dashboard-box-horizontal">
        <div class="">
          <div
            v-if="stats.data.sentiment_score <= -11"
            class="sentiment-icons2 space-5"
          >
            <img src="../assets/mad.png" />
          </div>
          <div
            v-else-if="
              stats.data.sentiment_score > -11 &&
                stats.data.sentiment_score < 49
            "
            class="sentiment-icons2 space-5"
          >
            <img src="../assets/neutral.png" />
          </div>
          <div
            v-else-if="stats.data.sentiment_score > 49"
            class="sentiment-icons2 space-5"
          >
            <img src="../assets/happy.png" />
          </div>
        </div>
        <br />
        <span class="box-number space-5" style="align:left; color:green;"
          >{{
            (
              (stats.data.positive_sentiment_count / stats.data.total_count) *
              100
            ).toFixed(1)
          }}%</span
        >
        Positive Sentiment<br />
        <span class="box-number"
          >{{
            (
              (stats.data.negative_sentiment_count / stats.data.total_count) *
              100
            ).toFixed(1)
          }}%</span
        >
        Negative Sentiment
      </div>
      <div class="dashboard-box-horizontal">
        <span class="box-number">{{ stats.data.total_count }}</span>
        <span class="box-header">Total Feedback</span>
        <span class="box-footer">past 6 weeks</span>
      </div>
    </div>

    <div class="full-box">
      <h2 class="bold">MOST COMMON CUSTOMER PHRASES</h2>
      <div class="word-cloud">
        <vue-word-cloud
          style="
            height: 340px;
            width: 100%;
          "
          :words="wordcloud.data"
          :color="
            ([, weight, sentiment]) =>
              sentiment > 49
                ? '#00a660'
                : sentiment > -11
                ? '#929292'
                : '#de4c40'
          "
          :spacing="0.8"
          :animation-duration="5"
          :animation-overlap="5"
          animation-easing="ease-in-out"
          font-family="Merienda"
        >
          <template v-slot="props">
            <div style="cursor: pointer;" @click="onWordClick(props.text)">
              {{ props.text }}
            </div>
          </template>
        </vue-word-cloud>
      </div>
    </div>

    <div class="feedback-list">
      <div class="search-filter">
        <div class="sentiment-filter">
          <div>Sentiment Filter:</div>
          <img src="../assets/mad.png" @click="sentimentFilter(1)" />
          <img src="../assets/neutral.png" @click="sentimentFilter(5)" />
          <img src="../assets/happy.png" @click="sentimentFilter(10)" />
        </div>
        <div
          v-if="Math.ceil(feedbacks.total_items / per_page) >= page"
          class="pagination"
        >
          <button
            v-if="page > 1"
            class="button button-100 page-back"
            @click="pageBack"
          >
            Back
          </button>
          <div class="pagination-page">
            Page {{ page }} of {{ Math.ceil(feedbacks.total_items / per_page) }}
          </div>
          <button
            v-if="page < Math.ceil(feedbacks.total_items / per_page)"
            class="button button-100 page-next"
            @click="pageNext"
          >
            Next
          </button>
        </div>
      </div>
      <div class="clearfix" />
      <div
        v-for="feedback in feedbacks.data"
        :key="feedback.id"
        class="feedback-item"
      >
        <FeedbackItem :feedback="feedback" />
      </div>
      <div class="clearfix" />
      <div
        v-if="Math.ceil(feedbacks.total_items / per_page) >= page"
        class="pagination"
      >
        <button
          v-if="page > 1"
          class="button button-100 page-back"
          @click="pageBack"
        >
          Back
        </button>
        <div class="pagination-page">
          Page {{ page }} of {{ Math.ceil(feedbacks.total_items / per_page) }}
        </div>
        <button
          v-if="page < Math.ceil(feedbacks.total_items / per_page)"
          class="button button-100 page-next"
          @click="pageNext"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardTitleSearch from "@/components/DashboardTitleSearch";
import FeedbackItem from "@/components/FeedbackItem";
import VueWordCloud from "vuewordcloud";
import api from "@/api/index";
const apiServiceFeedback = new api.APIServiceFeedback();
const apiService = new api.APIServiceFeedbackDashboard();

export default {
  name: "DashboardFeedback",
  components: {
    DashboardTitleSearch,
    FeedbackItem,
    [VueWordCloud.name]: VueWordCloud
  },
  data() {
    return {
      feedbacks: [],
      rank: this.$route.query.rank,
      satisfaction_percentage: this.$route.query.sat_percent,
      page: 1,
      stats: {},
      per_page: 25,
      total_items: 0,
      total_pages: 0,
      wordcloud: [],
      channel_name: "",
      property_id: this.$route.params.id,
      property_name: this.$route.params.property_name,
      customer_journey_cat_id: parseInt(
        this.$route.params.customer_journey_cat_id
      ),
      cat_name: "",
      sentimentScore: 0
    };
  },
  created() {
    this.getPropertyFeedback();
    this.getPropertyWordCloudByCustomerCategoryForWordCloudGraphic();
    this.getPropertyFeedbackCustomerJourneyCategoryStats();
  },
  methods: {
    getPropertyFeedback: function() {
      apiServiceFeedback
        .getFeedback(
          this.$route.params.id,
          this.page,
          this.sentimentScore,
          this.customer_journey_cat_id
        )
        .then(data => {
          this.feedbacks = data;
          this.isLoading = false;
        });
    },
    getPropertyWordCloudByCustomerCategoryForWordCloudGraphic: function() {
      apiService
        .getPropertyWordCloudByCustomerCategoryForWordCloudGraphic(
          this.$route.params.id,
          this.customer_journey_cat_id
        )
        .then(data => {
          this.wordcloud = data;
        });
    },
    getPropertyFeedbackCustomerJourneyCategoryStats: function() {
      apiService
        .getPropertyFeedbackCustomerJourneyCategoryStats(
          this.$route.params.id,
          this.customer_journey_cat_id
        )
        .then(data => {
          this.stats = data;
          this.channel_name = data.data.category_channel_name;
          this.cat_name = data.data.category_name;
        });
    },
    pageBack: function() {
      this.page = this.page - 1;
      this.getPropertyFeedback();
      window.scrollTo(0, 0);
    },
    pageNext: function() {
      this.page = this.page + 1;
      this.getPropertyFeedback();
      window.scrollTo(0, 0);
    },
    sentiment: function(mcss) {
      if (mcss < -5) {
        return "Negative";
      } else if (mcss > -5 && mcss <= 20) {
        return "Neutral";
      } else {
        return "Positive";
      }
    },
    sentimentFilter: function(score) {
      this.sentimentScore = score;
      this.getPropertyFeedback();
    }
  }
};
</script>

<style>
#feedback {
  margin: 0 0;
}
.dashboard {
  lost-utility: clearfix;
}

.dashboard-box-horizontal {
  lost-column: 1/3;
  height: 160px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  padding: 28px 0;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #cfd1d3;
}
.dashboard-box-horizontal .box-header {
  font-size: 21px;
  display: block;
}
.dashboard-box-horizontal .box-number {
  font-size: 30px;
  font-weight: bold;
  color: #c03131;
}
.dashboard-box-horizontal .box-footer {
  font-size: 14px;
  display: block;
}
.space-5 {
  padding-bottom: 5px;
  margin-bottom: 5px;
}
.four-lines {
  padding: 16px;
}
.sentiment-icons2 img {
  width: 30px;
  position: absolute;
  float: right;
}
.feedback-list {
  lost-utility: clearfix;
}
.feedback-item {
  lost-column: 1/2;
}
.feedback-rating {
  width: 100%;
  float: left;
}
.feedback-rating div {
  float: left;
  width: 100px;
}
.sentiment-filter div {
  padding-top: 5px;
  padding-right: 5px;
  float: left;
}
.sentiment-filter img {
  float: left;
  width: 30px;
}
.sentiment-icons {
  text-align: center;
}
.sentiment-icons img {
  width: 30px;
  padding-top: 5px;
}
.pagination {
  float: right;
  margin-bottom: 10px;
}
.pagination-page {
  padding-top: 12px;
  padding-right: 5px;
  float: left;
}
.ngrams {
  padding: 0 3px 10px 10px;
  margin-bottom: 20px;
}
.ngrams-box {
  lost-column: 1/2;
}
.ngram span {
  font-size: 20px;
}

@media (max-width: 870px) {
  .feedback-item {
    lost-column: 1/1;
  }
}

@media (max-width: 480px) {
  .full-box {
    lost-utility: clearfix;
  }
  h1 {
    font-size: 20px;
  }
}
</style>
